import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from "@mui/material";

/**
 * Two-button confirmation modal. Use for destructive or otherwise
 * irreversible actions.
 *
 *   <ConfirmDialog
 *     open={…}
 *     onClose={…}
 *     onConfirm={…}
 *     title="Delete vendor?"
 *     description="This will permanently remove …"
 *     confirmLabel="Delete"
 *     confirmColor="error"
 *   />
 */
export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = "Confirm",
  confirmColor = "primary",
  cancelLabel = "Cancel",
  submitting = false,
  error,
}) {
  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {typeof description === "string" ? (
          <DialogContentText>{description}</DialogContentText>
        ) : (
          description
        )}
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Stack
          direction={{ xs: "column-reverse", sm: "row" }}
          spacing={1}
          sx={{ width: { xs: "100%", sm: "auto" } }}
        >
          <Button
            onClick={onClose}
            disabled={submitting}
            variant="outlined"
            fullWidth={false}
          >
            {cancelLabel}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={submitting}
            variant="contained"
            color={confirmColor}
            startIcon={
              submitting ? <CircularProgress size={14} color="inherit" /> : null
            }
          >
            {confirmLabel}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
